import { render, staticRenderFns } from "./LoanAccrualHistoryReport.vue?vue&type=template&id=c0faff4e&scoped=true&"
import script from "./LoanAccrualHistoryReport.vue?vue&type=script&lang=js&"
export * from "./LoanAccrualHistoryReport.vue?vue&type=script&lang=js&"
import style0 from "./LoanAccrualHistoryReport.vue?vue&type=style&index=0&id=c0faff4e&lang=scss&scoped=true&"
import style1 from "./LoanAccrualHistoryReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0faff4e",
  null
  
)

export default component.exports